<div class="welcome-container">
  <!-- Animated Background -->
  <div class="animated-bg">
    <div class="gradient-orb orb-1"></div>
    <div class="gradient-orb orb-2"></div>
    <div class="gradient-orb orb-3"></div>
    <div class="gradient-orb orb-4"></div>
    <div class="gradient-orb orb-5"></div>
    <div class="floating-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>
  </div>

  <div class="main-wrapper">
    <!-- Left Hero Section -->
    <div class="hero-section fade-in-left">
      <div class="hero-overlay"></div>
      <img src="assets/images/sarvodaya-42.jpg" class="hero-image" alt="PayDay Hero" loading="eager" fetchpriority="high" decoding="async">
      <div class="hero-content">
        <h1 class="hero-title">Get Your Pay<br><span class="highlight">While You Work</span></h1>
        <p class="hero-subtitle">No more waiting for salary day</p>
      </div>
    </div>

    <!-- Right Content Section -->
    <div class="content-section">
      <div class="content-wrapper fade-in-up">
        <!-- Logo -->
        <div class="logo-container">
          <img src="assets/images/logo_images/PAYDAY 1.png" alt="Cixor Logo" class="main-logo" loading="eager" decoding="async">
        </div>

        <!-- Welcome Header -->
        <div class="welcome-header">
          <p class="tagline">Everyday is a PayDay</p>
          <h2 class="welcome-title">
            Welcome to <span class="brand-gradient">CIXOR PayDay</span>
          </h2>
        </div>

        <!-- Description -->
        <p class="welcome-description">
          Bridge the gap between work and pay. CIXOR PayDay gives you access to your earned salary instantly in real-time, while employers receive powerful tools for control and insights into payroll management.
        </p>

        <!-- Feature Labels -->
        <!-- <div class="feature-pills">
          <span class="label">💡 Instant Access</span>
          <span class="label">🔒 Secure</span>
          <span class="label">⚡ Real-Time</span>
          <span class="label">📊 Insights</span>
        </div> -->

        <!-- Employer Section -->
        <div class="action-card employer-card stagger-1">
          <div class="card-header">
            <div class="card-icon employer-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <h3 class="card-title">For Employers</h3>
          </div>
          <div class="card-buttons">
            <button class="btn btn-primary" (click)="navigateToRegister()">
              <span>New Registration</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>
            <button class="btn btn-secondary" (click)="navigateToLogin()">
              <span>Login</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                <polyline points="10 17 15 12 10 7"></polyline>
                <line x1="15" y1="12" x2="3" y2="12"></line>
              </svg>
            </button>
          </div>
        </div>

        <!-- Employee Section -->
        <div class="action-card employee-card stagger-2">
          <div class="card-header">
            <div class="card-icon employee-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
                <line x1="12" y1="18" x2="12.01" y2="18"></line>
              </svg>
            </div>
            <h3 class="card-title">For Employees</h3>
          </div>
          <p class="card-subtitle">Download the app to access your earned wages</p>
          <div class="app-buttons">
            <a class="app-btn android-btn" target="_blank"
               href="https://play.google.com/store/apps/details?id=com.cixor.payday&hl=en">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.523 15.341c-.378 0-.717-.146-.967-.396-.25-.25-.396-.589-.396-.967s.146-.717.396-.967c.25-.25.589-.396.967-.396s.717.146.967.396c.25.25.396.589.396.967s-.146.717-.396.967c-.25.25-.589.396-.967.396zm-11.046 0c-.378 0-.717-.146-.967-.396-.25-.25-.396-.589-.396-.967s.146-.717.396-.967c.25-.25.589-.396.967-.396s.717.146.967.396c.25.25.396.589.396.967s-.146.717-.396.967c-.25.25-.589.396-.967.396zm11.405-6.02l1.97-3.411c.11-.19.045-.434-.145-.544-.19-.11-.434-.045-.544.145l-1.994 3.453c-1.524-.695-3.233-1.083-5.169-1.083s-3.645.388-5.169 1.083L4.837 5.511c-.11-.19-.354-.255-.544-.145-.19.11-.255.354-.145.544l1.97 3.411C2.93 11.231.859 14.457.859 18.118h22.282c0-3.661-2.071-6.887-5.259-8.797z"/>
              </svg>
              <div class="app-info">
                <span class="app-label">Get it on</span>
                <span class="app-store">Google Play</span>
              </div>
            </a>
            <a class="app-btn ios-btn" target="_blank"
               href="https://apps.apple.com/us/app/cixor-payday/id6755372821">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
              <div class="app-info">
                <span class="app-label">Download on the</span>
                <span class="app-store">App Store</span>
              </div>
            </a>
          </div>
        </div>

        <!-- Footer -->
        <div class="footer stagger-3">
          <a href="/terms-and-conditions" class="footer-link">Terms & Conditions</a>
          <span class="footer-divider">•</span>
          <span class="footer-version">Version {{appVersion}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
